<template>
    <el-form ref="form" label-width="165px" :rules="rules" :model="dioForm">
        <el-form-item v-if="isSysAdmin" :label="$t('labelTitle.Range')" prop="scopeId">
            <el-select v-if="!isShowText" style="width: 250px" v-model="dioForm.scopeId">
                <el-option v-for="item in rangeArray" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
            <span v-else>{{ dioForm.sceneName }}</span>
        </el-form-item>
        <el-form-item :label="$t('detection.mInterval')" prop="name">
            <el-input v-model.trim="dioForm.name" style="width: 250px" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item :label="$t('detection.unitMeasurement')" prop="unitId">
            <el-select style="width: 250px" v-model="dioForm.unitId" @change="changeCompany" v-if="!isShowText">
                <el-option v-for="item in UnitMeasurement" :key="item.id" :label="$t(item.label)"
                    :value="item.id"></el-option>
            </el-select>
            <span v-else>{{ company }}</span>
        </el-form-item>
        <el-form-item :label="$t('detection.intervalValue')" prop="min">
            <el-input v-model.trim="dioForm.min" style="width: 80px"></el-input>
            <span class="companyClass">{{ company || '--' }}</span>
            <span class="mr10">~</span>
            <el-input v-model.trim="dioForm.max" style="width: 80px"></el-input>
            <span class="companyClass">{{ company || '--' }}</span>
        </el-form-item>
    </el-form>
</template>

<script>
import { shareScope } from '@/api/modules/public';
import formValidate from '@/utils/formValidate.js';
import { getIsSys } from '@/utils/permission';
export default {
    props: ['UnitMeasurement', 'optareStatus'],
    watch: {
        optareStatus(newVal) {
            this.isShowText = newVal;
        }
    },
    mixins: [formValidate],
    computed: {
        isSysAdmin() {
            return getIsSys();
        },
        rules() {
            let checkInter = (rule, value, callback) => {
                let valueMax = this.dioForm.max;
                let reg = /^-?\d+(.\d{1,2})?$/;

                if ((!reg.test(Number(value)) && !Number(value)) || (!reg.test(valueMax) && valueMax)) {
                    callback(new Error(this.$t('detection.onlyNumber')));
                }
                if (value && valueMax) {
                    if (Number(value) > Number(valueMax)) {
                        callback(new Error(this.$t('detection.minMax')));
                    } else {
                        callback();
                    }
                } else {
                    if (!value && !valueMax) {
                        callback(new Error(this.$t('detection.notMinEmpty')));
                    }
                    if (!valueMax && valueMax !== 0) {
                        callback(new Error(this.$t('detection.notMaxEmpty')));
                    }
                    callback();
                }
            };
            return {
                name: [
                    {
                        required: true,
                        message: this.$t('messageTitle.ContentNotEmpty').toString(),
                        trigger: 'blur'
                    },
                    {
                        min: 4,
                        max: 50,
                        message: this.$t('messageTitle.CharacterLengthAt4-20').toString(),
                        trigger: 'blur'
                    }
                ],
                unitId: [
                    {
                        required: true,
                        message: this.$t('detection.UOMnotEmpty'),
                        trigger: 'change'
                    }
                ],
                scopeId: [
                    {
                        required: true,
                        message: this.$t('messageTitle.RangeCanNotBeEmpty').toString(),
                        trigger: 'change'
                    }
                ],
                min: [
                    {
                        required: true,
                        message: this.$t('detection.notEmpty'),
                        trigger: 'blur'
                    },
                    {
                        required: true,
                        validator: checkInter,
                        trigger: 'blur'
                    }
                ]
            };
        }
    },
    data() {
        return {
            dioForm: {
                scopeId: null,
                name: null,
                unitId: null,
                min: null,
                max: null
            },
            rangeArray: [],
            untilArray: [],
            company: '',
            isShowText: false
        };
    },
    created() {
        this.isSysAdmin ? this.rangeHttp() : true;
    },
    methods: {
        rangeHttp() {
            shareScope({ tab: 1 }).then(({ result }) => {
                this.rangeArray = result.slice(1);
            });
        },
        changeCompany(id) {
            // const regex = /(?<=\()(.+?)(?=\))/g;
            // this.company = item.label.match(regex)[0];
            this.UnitMeasurement.forEach(item => {
                if (id === item.id) {
                    this.company = item.name;
                }
            });
        },
        async justify() {
            // 校验成功则方法自动返回true，校验方法报错则说明校验失败，返回false
            try {
                return await this.$refs['form'].validate();
            } catch (error) {
                return false;
            }
        },
        clearValidate() {
            this.company = '';
            if (this.$refs.form) {
                this.$refs.form.resetFields();
            }
        }
    }
};
</script>

<style scoped>
.companyClass {
    font-size: 20px;
    margin: 0 8px;
    vertical-align: middle;
}

.mr10 {
    margin-right: 8px;
}
</style>
